import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// Auto-print bus. UI callers (Ticket.DoCommit) push una print request y
// el root-level overlay component subscribes & processes it. Vivir en el
// root mantiene el DOM del receipt vivo aunque el editor (que en BARRA
// es el unico ui-ticket-print suscrito al ticket.OnPrint) muera antes
// de que el setTimeout interno de SendTicket pueda renderizar y mandar
// con los datos completos (invceno/series/QR).
//
// Dos modos:
// - terminal != null: imprimir en terminal paytef (HTML).
// - terminal == null + receiptData: imprimir en BAR printers locales
//   (ESC/POS via WS print service) usando los flags en receiptData
//   (paytefAutoprint, isauto, drawer) para decidir _devices.
export interface PaytefAutoprintRequest {
    ticket: any;
    terminal: any;
    cryptoReady: Promise<any> | null;
    // Confirmacion del super.DoCommit en backend. Si rechaza, el
    // overlay no envia el receipt — evita ticket fantasma cuando el
    // commit falla.
    commitReady: Promise<any> | null;
    // Si terminal es null, el overlay usa receiptData para invocar
    // sendToBARReceipt en su embeddedPrint.
    receiptData: { isauto: boolean, drawer: boolean, paytefAutoprint: boolean } | null;
}

@Injectable({ providedIn: 'root' })
export class paytefAutoprintService {
    private _requests$ = new Subject<PaytefAutoprintRequest>();

    get requests$(): Observable<PaytefAutoprintRequest> {
        return this._requests$.asObservable();
    }

    requestPrint(ticket: any, terminal: any, cryptoReady: Promise<any> | null, commitReady: Promise<any> | null = null){
        if (!ticket || !terminal){
            console.warn("[PAYTEF AUTOPRINT] Ignored request — missing ticket or terminal");
            return;
        }
        this._requests$.next({ ticket, terminal, cryptoReady, commitReady, receiptData: null });
    }

    // Receipt de cobro a impresora BAR via overlay root-level. Sin
    // terminal — el overlay invoca sendToBARReceipt en su embeddedPrint.
    requestBarReceipt(ticket: any, receiptData: { isauto: boolean, drawer: boolean, paytefAutoprint: boolean }, ticketReady: Promise<any> | null, commitReady: Promise<any> | null){
        if (!ticket){
            console.warn("[BAR AUTOPRINT] Ignored request — missing ticket");
            return;
        }
        this._requests$.next({ ticket, terminal: null, cryptoReady: ticketReady, commitReady, receiptData });
    }
}
